module.exports = __webpack_public_path__ + "img/qg2.d6f014f0.jpg";